import React from 'react';
import bookingStore, { BookingStore } from './modules/booking';
import favouritesStore, { FavouritesStore } from './modules/favourites';
import langStore, { LangStore } from './modules/lang';
import mapStore, { MapStore } from './modules/map';
import poiStore, { PoiStore } from './modules/poi';

export type RootStore = {
  bookingStore: BookingStore;
  favouritesStore: FavouritesStore;
  langStore: LangStore;
  mapStore: MapStore;
  poiStore: PoiStore;
};

const store: RootStore = {
  bookingStore,
  favouritesStore,
  langStore,
  mapStore,
  poiStore
};

const StoreContext = React.createContext<RootStore>(store);

export const useStore = () => React.useContext(StoreContext);

export { bookingStore, favouritesStore, langStore, mapStore, poiStore };
